const MeauxminyDjSetsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/eauxminy/club-kawaii-meauxminy-guest-spot" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-p8ru6SzyL81sWu3L-ODcRvQ-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Meauxminy @ Club Kawaii (Hosted by ANJU Online!)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/eauxminy/sunday2-wip" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-2CVLufTNzqL35zqH-5cOZFA-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Sunday in CK 2</strong><br/>
                (Full Set)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://m.soundcloud.com/eauxminy/sunday-in-ck" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Y8GZqZzQVypyKfvr-DAql7A-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Sunday in CK</strong><br/>
                (Full Set)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/eauxminy/ck-mix-2-wip" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RgC0cCeAWMy54tm7-jAIPpg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DUBSCAPE</strong><br/>
                (Full Set)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">DJ Set</p>
            <a href="https://soundcloud.com/eauxminy/club-kawaii-mix" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-Qv5Ft6dyNjd4CyCd-Zrh9Bg-t500x500.jpg" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Meauxminy @ Club Kawaii</strong><br/>
                (Full Set)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default MeauxminyDjSetsStatic;